/* global $ */
import React, { Component } from 'react'
import { omit } from 'ramda'
import PropTypes from 'prop-types'

class SelectPicker extends Component {
  componentDidMount () {
    this.element = $(this.select).selectpicker()
    this.element.on('changed.bs.select', this.emitChange.bind(this))

    if (!this.props.value && this.props.defaultValue) {
      this.element.selectpicker('val', this.props.defaultValue)
      this.emitChange()
    }

    this.element.selectpicker('val', this.props.value)
  }

  componentWillUnmount () {
    this.element.off('changed.bs.select')
    this.element.selectpicker('destroy')
  }

  componentDidUpdate () {
    this.element.selectpicker('val', this.props.value)
    this.element.selectpicker('refresh')
  }

  emitChange () {
    this.props.onChange(this.element.selectpicker('val'))
  }

  render () {
    return (
      <select
        ref={node => (this.select = node)}
        title={this.props.title}
        {...omit(['onChange', 'value', 'defaultValue'])(this.props)}
      >
        {this.props.children}
      </select>
    )
  }
}

SelectPicker.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  children: PropTypes.any,
  title: PropTypes.string
}

export const SelectPickerField = ({
  input: { value, onChange },
  meta,
  ...props
}) => {
  return <SelectPicker onChange={onChange} value={value} {...props} />
}

SelectPickerField.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export default SelectPicker



// WEBPACK FOOTER //
// ./src/components/form/selectpicker/index.js